import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'communityJackpot', en);
i18next.addResources('fr', 'communityJackpot', fr);

declare global {
  interface RegisteredLocales {
    communityJackpot: typeof en;
  }
}
